import EventDispatcher from './EventDispatcher';
import Global from './Global';

export default class PlayToWin {
  constructor() {
    // document
    //   .querySelector('#playToWin_btn')
    //   .addEventListener('click', this.onPlay.bind(this));
  }

  init() {
    this.isChecked = true;

    this.events = EventDispatcher.getObj();
    this.events.addEventListener('LOADER_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAME_EVENTS', this.onEvents.bind(this));
    this.events.addEventListener('GAMESCENE_EVENTS', this.onEvents.bind(this));
    // setTimeout(()=>{
    //     this.onOkay();
    // }, 1000)
  }

  onEvents(data) {
    switch (data.message.event_type) {
      case 'show_screen':
        this.showScreen(data.message.data.screenKey);
        break;
    }
  }

  showScreen(screenKey) {
    if (screenKey != 'PlayToWin') return false;

    document.querySelector('#playToWin_scr').classList.add('active');
  }

  hideControls() {}

  onPlay() {
    this.events.dispatchEvent({
      type: 'LOADER_EVENTS',
      message: {
        event_type: 'switch_page',
        data: {
          screenKey: 'Form',
        },
      },
    });
  }

  onOkay() {
    document.querySelector('#score_sec').classList.add('active');
    document.querySelector('#playToWin_scr').classList.remove('active');
    setTimeout(() => {
      // document.querySelector(".game_footer").classList.add("active2");
      document.querySelector('.game_timer_sec').classList.add('active');
    }, 100);
    this.events.dispatchEvent({
      type: 'GAME_EVENTS',
      message: {
        event_type: 'level_selected',
        data: {
          level: 1,
        },
      },
    });
  }
}
